import type { ArticleBlock } from "@/types/content";

export default function ArticleBody({ content }: { content: ArticleBlock[] }) {
  return (
    <div className="mt-8">
      {content.map((block, index) => {
        if (block.type === "h2") {
          return (
            <h2
              key={`h2-${index}`}
              id={`heading-${index}`}
              className="mt-10 scroll-mt-32 font-heading text-xl font-bold text-foreground-950 md:text-2xl"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "h3") {
          return (
            <h3
              key={`h3-${index}`}
              id={`heading-${index}`}
              className="mt-8 scroll-mt-32 font-heading text-lg font-bold text-foreground-900"
            >
              {block.text}
            </h3>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={`quote-${index}`}
              className="mt-6 border-l-2 border-primary-400 bg-background-100 px-5 py-4 text-sm italic leading-relaxed text-foreground-700 md:text-base"
            >
              {block.text}
            </blockquote>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={`list-${index}`} className="mt-5 space-y-2.5">
              {(block.items ?? []).map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700 md:text-base">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-500" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={`p-${index}`} className="mt-5 text-sm leading-[1.9] text-foreground-700 md:text-base">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}